export enum FeatureFlagStatus {
  ENABLED = 'enable',
  DISABLED = 'disable'
}

export enum FeatureFlagParameters {
  DETAILED_PO_REPORT = '/xpt-fe/detailed-po-report',
  AG_GRID_LICENSE_KEY = '/xpt-fe/ag-grid-license',
  ACCESS_REQUEST_SELF_SERVICE = '/xpt-fe/access-request-self-service',
  NOTIFICATIONS = '/xpt-fe/notifications',
  ACTUALS_MULTI_CC_EXPORT = '/xpt-fe/actuals-multi-cc-export'
}
